module.exports = __webpack_public_path__ + "img/binoculars-fill.d685a3cc.svg";